import ADMIN_ACTIONS from "../actions/AdminActions";

const {
  ADMIN_DATA_LOADING,
  SET_ADMIN_AUTH_TOKENS,
  SET_ADMIN_USER_DATA,
  ADMIN_LOGOUT,
  SET_ADMIN_ERROR,
  CLEAR_ADMIN_ERRORS,
  SET_ADMIN_MESSAGE,
} = ADMIN_ACTIONS;

export default function adminReducer(state, action) {
  switch (action.type) {
    case ADMIN_DATA_LOADING:
      return {
        ...state,
        dataLoading: action.payload,
      };

    case SET_ADMIN_AUTH_TOKENS:
      const { accessToken, refreshToken } = action.payload;

      if (accessToken) {
        localStorage.setItem("adminAccessToken", accessToken);
      } else {
        localStorage.removeItem("adminAccessToken");
      }

      if (refreshToken) {
        localStorage.setItem("adminRefreshToken", refreshToken);
      } else {
        localStorage.removeItem("adminRefreshToken");
      }

      return {
        ...state,
        accessToken,
        refreshToken,
      };

    case SET_ADMIN_USER_DATA:
      return {
        ...state,
        userData: action.payload,
      };

    case ADMIN_LOGOUT:
      localStorage.removeItem("adminAccessToken");
      localStorage.removeItem("adminRefreshToken");
      return {
        ...state,
        accessToken: null,
        refreshToken: null,
        userData: {},
        error: null,
        message: null,
      };

    case SET_ADMIN_ERROR:
      return {
        ...state,
        error: action.payload,
        dataLoading: false,
      };

    case CLEAR_ADMIN_ERRORS:
      return {
        ...state,
        error: null,
        message: null,
      };

    case SET_ADMIN_MESSAGE:
      return {
        ...state,
        message: action.payload,
        error: null,
        dataLoading: false,
      };

    default:
      return state;
  }
}
